import { render } from "./DetailedItem.vue?vue&type=template&id=ed5a861e&scoped=true"
import script from "./DetailedItem.vue?vue&type=script&lang=js"
export * from "./DetailedItem.vue?vue&type=script&lang=js"

import "./DetailedItem.vue?vue&type=style&index=0&id=ed5a861e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed5a861e"

export default script